import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddCategory = () => {
  const [formData, setFormData] = useState({
    name: '',
    status: '1'
  });
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    payload.append('name', formData.name);
    payload.append('status', formData.status);
    if (imageFile) payload.append('image', imageFile);

    try {
      await postRequest('categories', payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Category added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/categories');
      }, 2000);
    } catch (error) {
      console.error('Failed to add category:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Category</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                placeholder="Enter category name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="image">Image</label>
              <input
                id="image"
                type="file"
                className="form-control"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
              />
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCategory;
